import { c as classofRaw, t as toPrimitive, o as objectDefineProperty, a as createPropertyDescriptor, w as wellKnownSymbol, i as isObject, e as engineV8Version, f as fails, _ as _export, b as toObject, d as toLength, g as toIndexedObject, h as indexedObject, j as functionBindContext, k as arrayMethodUsesToLength, l as aFunction, m as objectKeys, n as descriptors, p as objectPropertyIsEnumerable, q as _asyncToGenerator, S as SocialLoginResponseStatus, r as _typeof, s as SocialType, A as AppleSdkLoader, G as GoogleSdkLoader, W as WeChatSdkLogin, u as AppleSdkLogin, v as GoogleSdkLogin, x as _slicedToArray, y as _objectSpread2, z as startULRpcExecutor } from '../chuck/startULRpcExecutor-e7ee3e58.js';

// https://tc39.github.io/ecma262/#sec-isarray

var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
};

var SPECIES = wellKnownSymbol('species'); // `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate

var arraySpeciesCreate = function (originalArray, length) {
  var C;

  if (isArray(originalArray)) {
    C = originalArray.constructor; // cross-realm fallback

    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }

  return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};

    constructor[SPECIES$1] = function () {
      return {
        foo: 1
      };
    };

    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'; // We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679

var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species

_export({
  target: 'Array',
  proto: true,
  forced: FORCED
}, {
  concat: function concat(arg) {
    // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;

    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];

      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }

    A.length = n;
    return A;
  }
});

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () {
      throw 1;
    }, 1);
  });
};

var nativeJoin = [].join;
var ES3_STRINGS = indexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join

_export({
  target: 'Array',
  proto: true,
  forced: ES3_STRINGS || !STRICT_METHOD
}, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var push = [].push; // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation

var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;

    for (; length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);

      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
            case 3:
              return true;
            // some

            case 5:
              return value;
            // find

            case 6:
              return index;
            // findIndex

            case 2:
              push.call(target, value);
            // filter
          } else if (IS_EVERY) return false; // every
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};

var $map = arrayIteration.map;
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map'); // FF49- issue

var USES_TO_LENGTH = arrayMethodUsesToLength('map'); // `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
}, {
  map: function map(callbackfn
  /* , thisArg */
  ) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }

      index += i;

      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }

    for (; IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }

    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var $reduce = arrayReduce.left;
var STRICT_METHOD$1 = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH$1 = arrayMethodUsesToLength('reduce', {
  1: 0
}); // `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD$1 || !USES_TO_LENGTH$1
}, {
  reduce: function reduce(callbackfn
  /* , initialValue */
  ) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var propertyIsEnumerable = objectPropertyIsEnumerable.f; // `Object.{ entries, values }` methods implementation

var createMethod$2 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;

    while (length > i) {
      key = keys[i++];

      if (!descriptors || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }

    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod$2(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod$2(false)
};

var $entries = objectToArray.entries; // `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries

_export({
  target: 'Object',
  stat: true
}, {
  entries: function entries(O) {
    return $entries(O);
  }
});

var FacebookSdkLogin = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (FB) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {
              status: SocialLoginResponseStatus.LoadError
            });

          case 3:
            return _context.abrupt("return", new Promise(function (resolve) {
              FB.login(function (response) {
                if (response.status === 'connected' && response.authResponse) {
                  resolve({
                    code: response.authResponse.accessToken,
                    status: SocialLoginResponseStatus.Success
                  });
                } else if (response.status === 'unknown') {
                  resolve({
                    status: SocialLoginResponseStatus.Unknown
                  });
                } else {
                  resolve({
                    status: SocialLoginResponseStatus.Error
                  });
                }
              }, {
                scope: config.scope
              });
            }));

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              status: SocialLoginResponseStatus.Error,
              error: "".concat(_context.t0)
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));

  return function FacebookSdkLogin(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fbSDKVersion = 'v9.0';

var checkFBSdkLoaded = function checkFBSdkLoaded() {
  return (typeof FB === "undefined" ? "undefined" : _typeof(FB)) === 'object' && !!FB.init;
};

var waitForFacebookSDKLoad = function waitForFacebookSDKLoad() {
  var maxRetries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
  var retries = 0;
  return new Promise(function (resolve, reject) {
    var waitForFacebookSDKIntervalId = setInterval(function () {
      if (retries >= maxRetries) {
        window.clearInterval(waitForFacebookSDKIntervalId);
        reject(new Error("FB SDK load reached maximum retries, ".concat(maxRetries)));
      }

      retries += 1;

      if (checkFBSdkLoaded()) {
        window.clearInterval(waitForFacebookSDKIntervalId);
        resolve(true);
      }
    }, 100);
  });
};

var FacebookSdkLoader = function FacebookSdkLoader(config) {
  var culture = config.culture,
      appId = config.appId;

  if (checkFBSdkLoaded()) {
    return Promise.resolve(true);
  }

  return new Promise(function (resolve, reject) {
    if (document.getElementById('facebook-jssdk')) {
      resolve(true);
    }

    var sdkScript = document.createElement('script');
    sdkScript.id = 'facebook-jssdk';
    sdkScript.src = "https://connect.facebook.net/".concat(culture, "/sdk.js");
    sdkScript.async = true;
    sdkScript.defer = true;
    sdkScript.crossOrigin = 'anonymous';
    sdkScript.addEventListener('load', function () {
      waitForFacebookSDKLoad().then(function () {
        FB.init({
          appId: appId,
          version: fbSDKVersion,
          xfbml: false
        });
        resolve(true);
      }).catch(reject);
    });
    sdkScript.addEventListener('error', function () {
      return reject(new Error('FB SDK Error loading script.'));
    });
    sdkScript.addEventListener('abort', function () {
      return reject(new Error('FB SDK Script loading aborted.'));
    });
    document.body.appendChild(sdkScript);
  });
};

var onSocialSdkLoadHandler = function onSocialSdkLoadHandler(config) {
  switch (config.type) {
    case SocialType.FACEBOOK:
      return FacebookSdkLoader(config);

    case SocialType.GOOGLE:
      return GoogleSdkLoader(config);

    case SocialType.APPLE:
      return AppleSdkLoader(config);

    default:
      return Promise.resolve(false);
  }
};

var onSocialLoginHandler = function onSocialLoginHandler(config) {
  switch (config.type) {
    case SocialType.FACEBOOK:
      return FacebookSdkLogin(config);

    case SocialType.GOOGLE:
      return GoogleSdkLogin(config);

    case SocialType.APPLE:
      return AppleSdkLogin(config);

    case SocialType.WECHAT:
      return WeChatSdkLogin(config);

    default:
      return Promise.resolve({
        status: SocialLoginResponseStatus.NotImplemented
      });
  }
};

var onWindowSizeChangedHandler = function onWindowSizeChangedHandler(appIframe) {
  return function (height, width) {
    appIframe.style.height = "".concat(height, "px");
    appIframe.style.width = "".concat(width, "px");
  };
};

var $filter = arrayIteration.filter;
var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('filter'); // Edge 14- issue

var USES_TO_LENGTH$2 = arrayMethodUsesToLength('filter'); // `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$1 || !USES_TO_LENGTH$2
}, {
  filter: function filter(callbackfn
  /* , thisArg */
  ) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var AppIframeHelper;

(function (_AppIframeHelper) {
  var build = _AppIframeHelper.build = function (src, iframeConfig) {
    var style = iframeConfig.style,
        title = iframeConfig.title;
    var iframe = document.createElement('iframe');
    var attrs = {
      src: src,
      title: title,
      'data-cy': 'ul-app-frame',
      frameborder: '0',
      seamless: 'seamless',
      scrolling: 'yes',
      style: Object.keys(style).filter(function (k) {
        return style[k] !== undefined;
      }).map(function (k) {
        return "".concat(k, ": ").concat(style[k]);
      }).join(';'),
      sandbox: 'allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox'
    };

    for (var attr in attrs) {
      iframe.setAttribute(attr, attrs[attr]);
    }

    return iframe;
  };

  var buildQueryString = _AppIframeHelper.buildQueryString = function (query) {
    return Object.entries(query).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          v = _ref2[1];

      return v != null;
    }).map(function (pair) {
      return pair.map(encodeURIComponent).join('=');
    }).join('&');
  };
})(AppIframeHelper || (AppIframeHelper = {}));

var FullScreenWrapper;

(function (_FullScreenWrapper) {
  var setVh = function setVh() {
    // Trick to make app stitch to fit full screen in mobile
    // ref: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
  };

  var registerHeightStitchingEvent = _FullScreenWrapper.registerHeightStitchingEvent = function () {
    setVh();
    window.addEventListener('resize', setVh);
    return unregisterHeightStitchingEvent;
  };

  var unregisterHeightStitchingEvent = function unregisterHeightStitchingEvent() {
    window.removeEventListener('resize', setVh);
  };

  var containerAttr = {
    'data-cy': 'ul-app-frame-container',
    style: ['width: 100vw', 'min-height: 100vh', 'min-height: calc(var(--vh, 1vh) * 100)', 'display: flex'].join(';')
  };
  var iframeStyle = {
    'flex-grow': 1
  };

  var wrap = _FullScreenWrapper.wrap = function (iframe) {
    var container = document.createElement('div');

    for (var attr in containerAttr) {
      container.setAttribute(attr, containerAttr[attr]);
    }

    for (var style in iframeStyle) {
      iframe.style[style] = iframeStyle[style];
    }

    container.appendChild(iframe);
    return container;
  };
})(FullScreenWrapper || (FullScreenWrapper = {}));

var ConfigHelper;

(function (_ConfigHelper) {
  var withDefaults = _ConfigHelper.withDefaults = function (sdkConfig) {
    var _config$eventHandlers, _config$eventHandlers2;

    var iframe = sdkConfig.iframe;

    var config = _objectSpread2(_objectSpread2({
      appId: 'undefined-app-id'
    }, sdkConfig), {}, {
      iframe: _objectSpread2({
        style: {},
        title: 'Universal login'
      }, iframe !== null && iframe !== void 0 ? iframe : {})
    });

    if (!!(config === null || config === void 0 ? void 0 : config.useExternalNotification) && !((_config$eventHandlers = config.eventHandlers) === null || _config$eventHandlers === void 0 ? void 0 : _config$eventHandlers.onNotificationPush)) {
      throw new Error('Invalid configuration for external notification. Please add onNotificationPush handler.');
    }

    if (!!(config === null || config === void 0 ? void 0 : config.useExternalRoute) && !((_config$eventHandlers2 = config.eventHandlers) === null || _config$eventHandlers2 === void 0 ? void 0 : _config$eventHandlers2.onRouteChange)) {
      throw new Error('Invalid configuration for external route. Please add onRouteChange handler.');
    }

    return config;
  };
})(ConfigHelper || (ConfigHelper = {}));

var Logger;

(function (_Logger) {
  var createDefault = _Logger.createDefault = function (isDebug) {
    if (isDebug) {
      return {
        info: function info(str) {
          return console.info('Debug: UL Logger', str);
        },
        error: function error(errMsg, _error) {
          return console.error('Debug: UL Logger', {
            errMsg: errMsg,
            error: _error
          });
        }
      };
    }

    return {
      // default as do nothing
      info: function info() {},
      error: function error() {}
    };
  };
})(Logger || (Logger = {}));

var Measurement;

(function (_Measurement) {
  var createDefault = _Measurement.createDefault = function (isDebug) {
    if (isDebug) {
      return {
        send: function send(name, measurement, count, tags) {
          console.log("sending measurement", {
            name: name,
            measurement: measurement,
            count: count,
            tags: tags
          });
        }
      };
    }

    return {
      // default as do nothing
      send: function send() {}
    };
  };
})(Measurement || (Measurement = {}));

var LoadTracker;

(function (_LoadTracker) {
  var wrappedTimeout = function wrappedTimeout(callback, timeout) {
    var timerId = setTimeout(callback, timeout);
    return function () {
      if (timerId === null) return;
      clearTimeout(timerId);
      timerId = null;
    };
  };

  var start = _LoadTracker.start = function (logger, measurement, tags) {
    var startTime = Date.now();
    measurement.send('ul.sdk.load', 1, 1, tags);

    var trackStatus = function trackStatus(status, stopTime) {
      var timeDifference = (stopTime - startTime) / 1000;
      measurement.send('ul.sdk.spaload', timeDifference, 1, _objectSpread2(_objectSpread2({}, tags), {}, {
        status: status
      }));
      logger.info("ul.sdk.spaload ".concat(tags.appId, " ").concat(tags.path, " loaded with status: ").concat(status));
    }; // No event happened within 10 seconds


    var cancelTimeout = wrappedTimeout(function () {
      return trackStatus('timeout', Date.now());
    }, 10000);
    var isSpaLoaded = false;
    return {
      trackSpaLoad: function trackSpaLoad() {
        var eventTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
        cancelTimeout();
        trackStatus('success', eventTime);
        isSpaLoaded = true;
      },
      trackUnload: function trackUnload() {
        var eventTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
        cancelTimeout();

        if (!isSpaLoaded) {
          trackStatus('incomplete', eventTime);
        }

        measurement.send('ul.sdk.unload', (eventTime - startTime) / 1000, 1, tags);
      }
    };
  };
})(LoadTracker || (LoadTracker = {}));

var UL;

(function (_UL) {
  var load = _UL.load = function (selector, sdkConfig, logger, measurement) {
    var _ConfigHelper$withDef = ConfigHelper.withDefaults(sdkConfig),
        appId = _ConfigHelper$withDef.appId,
        cultureCode = _ConfigHelper$withDef.cultureCode,
        debugMode = _ConfigHelper$withDef.debugMode,
        fullScreen = _ConfigHelper$withDef.fullScreen,
        iframeConfig = _ConfigHelper$withDef.iframe,
        useExternalRoute = _ConfigHelper$withDef.useExternalRoute,
        useExternalNotification = _ConfigHelper$withDef.useExternalNotification,
        eventHandlers = _ConfigHelper$withDef.eventHandlers,
        path = _ConfigHelper$withDef.path,
        devOption = _ConfigHelper$withDef.devOption,
        changePasswordToken = _ConfigHelper$withDef.changePasswordToken,
        initialUserInfo = _ConfigHelper$withDef.initialUserInfo,
        whitelistedOrigin = _ConfigHelper$withDef.whitelistedOrigin,
        partnerCenterConfig = _ConfigHelper$withDef.partnerCenterConfig; // TODO: strip this out from SDK by using rollup-plugin-strip
    // get development options


    var expuser = devOption === null || devOption === void 0 ? void 0 : devOption.expuser;
    var explist = !!(devOption === null || devOption === void 0 ? void 0 : devOption.explist) ? Object.entries(devOption === null || devOption === void 0 ? void 0 : devOption.explist).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          expId = _ref2[0],
          v = _ref2[1];

      return "".concat(expId, "=").concat(v);
    }).join(',') : undefined;
    var origin = devOption === null || devOption === void 0 ? void 0 : devOption.origin; // TODO: should manage default filler in a better way

    var loggerToUse = logger !== null && logger !== void 0 ? logger : Logger.createDefault(debugMode);
    var measurementToUse = measurement !== null && measurement !== void 0 ? measurement : Measurement.createDefault(debugMode); // Ensure parent exists

    var parent = document.querySelector(selector);

    if (!parent) {
      loggerToUse.error("Error loading UL. No element with selector ".concat(selector, " was found."));
      return function () {};
    } // Generate RPC ID from app ID and unique selector


    var rpcId = "".concat(appId, "-").concat(selector);
    var versionSdk = '5.7.0'; // Start load tracker

    var tags = {
      appId: appId,
      path: path,
      cultureCode: !!cultureCode ? cultureCode : '',
      sdkVersion: versionSdk
    };

    var _LoadTracker$start = LoadTracker.start(loggerToUse, measurementToUse, tags),
        trackSpaLoad = _LoadTracker$start.trackSpaLoad,
        trackUnload = _LoadTracker$start.trackUnload; // Build Iframe


    var qs = {
      appId: appId,
      rpcId: rpcId,
      useExternalRoute: useExternalRoute,
      useExternalNotification: useExternalNotification,
      expuser: expuser,
      origin: origin,
      explist: explist,
      initialPath: path,
      fullScreen: fullScreen === null || fullScreen === void 0 ? void 0 : fullScreen.enable,
      debug: debugMode,
      sdkVersion: versionSdk,
      token: changePasswordToken,
      initialUsername: initialUserInfo === null || initialUserInfo === void 0 ? void 0 : initialUserInfo.username,
      initialAuthType: initialUserInfo === null || initialUserInfo === void 0 ? void 0 : initialUserInfo.type,
      partnerCenterSignUpType: partnerCenterConfig === null || partnerCenterConfig === void 0 ? void 0 : partnerCenterConfig.signUpType // Add params to pass here

    };
    var prependCultureCode = !!cultureCode ? "/".concat(cultureCode) : '';
    var src = whitelistedOrigin == null ? "".concat(prependCultureCode, "/ul/login?").concat(AppIframeHelper.buildQueryString(qs)) : "".concat(whitelistedOrigin).concat(prependCultureCode, "/ul/login?").concat(AppIframeHelper.buildQueryString(qs));
    var appIframe = AppIframeHelper.build(src, iframeConfig); // Build Iframe container

    var fullScreenWrapped = (fullScreen === null || fullScreen === void 0 ? void 0 : fullScreen.enable) && !(fullScreen === null || fullScreen === void 0 ? void 0 : fullScreen.withoutWrapper);
    var appContainer = fullScreenWrapped ? FullScreenWrapper.wrap(appIframe) : appIframe;
    var cleanUpHeightListener = fullScreenWrapped ? FullScreenWrapper.registerHeightStitchingEvent() : function () {}; // Build RPC executor

    var onSpaLoadHandler = function onSpaLoadHandler(spaLoadCompletedAt) {
      trackSpaLoad(spaLoadCompletedAt);
      (eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.onSpaLoad) && eventHandlers.onSpaLoad(spaLoadCompletedAt);
    };

    var procedures = _objectSpread2(_objectSpread2({}, eventHandlers), {}, {
      // Internal handlers
      onSocialSdkLoad: onSocialSdkLoadHandler,
      onSocialLogin: onSocialLoginHandler,
      onWindowSizeChanged: onWindowSizeChangedHandler(appIframe),
      onSpaLoad: onSpaLoadHandler // TODO Pass settings to SPA on another RPC call

    });

    var cleanUpRpcExecutor = startULRpcExecutor(rpcId, Object.entries(procedures).reduce(function (a, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];

      return v == null ? a : (a[k] = v, a);
    }, {}), whitelistedOrigin); // Append to DOM

    parent.appendChild(appContainer);
    loggerToUse.info("UL loaded iframe for app ".concat(appId, " at URL: ").concat(src)); // Cleanup for loaded iframe

    return function () {
      loggerToUse.info("UL unloading iframe for app ".concat(appId, " loaded at URL: ").concat(src));
      cleanUpRpcExecutor();
      cleanUpHeightListener();
      trackUnload();
      appContainer.parentNode.removeChild(appContainer);
    };
  };
})(UL || (UL = {}));

var UL$1 = UL;

export default UL$1;
